import * as $ from 'jquery';
import '@fancyapps/fancybox';

$('.fancybox').fancybox({
    modal: false,
    toolbar: false,
    smallBtn: true,
    iframe: {
        preload: false
    }
});